import type { ThemeUnit } from "../../types";
import { pxToUnit } from "../utils";

const createBorderWidth = (unit: ThemeUnit) =>
  ({
    none: "0",
    xs: pxToUnit(1, unit),
    sm: pxToUnit(2, unit),
    md: pxToUnit(3, unit),
    lg: pxToUnit(4, unit),
    xl: pxToUnit(6, unit),
  }) as const;

export const borderWidthRem = createBorderWidth("rem");

const createBorderRadius = (unit: ThemeUnit) =>
  ({
    none: "0",
    xs: pxToUnit(2, unit),
    sm: pxToUnit(4, unit),
    md: pxToUnit(8, unit),
    lg: pxToUnit(12, unit),
    xl: pxToUnit(16, unit),
    full: "9999px",
  }) as const;

export const borderRadiusRem = createBorderRadius("rem");
